// import firebase from "@firebase/app";
// import "@firebase/firestore";
// import "@firebase/analytics";
// const firebaseConfig = {
//     apiKey: "AIzaSyBYDrWjb2hg8RE9YGplEcebWnS5rxbneD8",
//     authDomain: "ihatoo.firebaseapp.com",
//     projectId: "ihatoo",
//     storageBucket: "ihatoo.appspot.com",
//     messagingSenderId: "839039624688",
//     appId: "1:839039624688:web:a0ff0019984ad96e6c6935",
//     measurementId: "G-9WRKPVBJ8E"
// }


// const app = firebase.initializeApp(firebaseConfig)
// let { logEvent } = firebase.analytics(app)

// export {
//     logEvent
// }

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBYDrWjb2hg8RE9YGplEcebWnS5rxbneD8",
    authDomain: "ihatoo.firebaseapp.com",
    projectId: "ihatoo",
    storageBucket: "ihatoo.appspot.com",
    messagingSenderId: "839039624688",
    appId: "1:839039624688:web:a0ff0019984ad96e6c6935",
    measurementId: "G-06HVMT30DX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const subLogEvent = (eventName, data) => {
    logEvent(analytics, eventName, data)
}

export {
    subLogEvent 
}